'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.saveApplicationForm = saveApplicationForm;
exports.showForm = showForm;
exports.hideForm = hideForm;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IS_VALID = 'nenudimse/applicationForm/IS_VALID';
var IS_VALID_SUCCESS = 'nenudimse/applicationForm/IS_VALID_SUCCESS';
var IS_VALID_FAIL = 'nenudimse/applicationForm/IS_VALID_FAIL';
var SHOW_FORM = 'nenudimse/applicationForm/SHOW_FORM';
var HIDE_FORM = 'nenudimse/applicationForm/HIDE_FORM';

var initialState = {
  saveError: null,
  isFormVisible: true
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case IS_VALID:
      return state; // 'saving' flag handled by redux-form
    case IS_VALID_SUCCESS:
      return (0, _extends3.default)({}, state, {
        saveError: null
      });
    case IS_VALID_FAIL:
      return typeof action.error === 'string' ? (0, _extends3.default)({}, state, {
        saveError: action.error
      }) : state;
    case SHOW_FORM:
      return (0, _extends3.default)({}, state, {
        isFormVisible: true
      });
    case HIDE_FORM:
      return (0, _extends3.default)({}, state, {
        isFormVisible: false
      });
    default:
      return state;
  }
}

function saveApplicationForm(data) {
  return {
    types: [IS_VALID, IS_VALID_SUCCESS, IS_VALID_FAIL],
    promise: function promise(client) {
      return client.post('/applicationForm/save', {
        data: data
      });
    }
  };
}

function showForm() {
  return {
    type: SHOW_FORM
  };
}

function hideForm() {
  return {
    type: HIDE_FORM
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/applicationForm.js
// module id = 117
// module chunks = 0